import './UserPersonalData.css';

import React from 'react';
import { Box } from '@mui/material';
import useGetUserData from '../../hooks/useGetUserData';
import { useState, useEffect } from 'react';
import { createLoadFactor } from '../../../b2b-plans/components/helper';
import EditText from '../../../b2b-common/EditText';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import CustomButton from '../../../b2b-common/CustomButton';

const UserPersonalData = ({ className = null }) => {
    const { t } = useB2BTranslation('b2b-users');
    const loadFactor = createLoadFactor("com.back2blu.users.service.loadfactor.UserLoadItem", 'BASIC');
    const { userData, triggerRefresh, saveUserData, isSaving } = useGetUserData(loadFactor);
    const [currentUserData, setCurrentUserData] = useState(null);

    // Sync currentUserData with userData when it loads
    useEffect(() => {
        if (userData) {
            setCurrentUserData(userData);
        }
    }, [userData]);

    if (!currentUserData) {
        return null;
    }

    const handleSave = async () => {
        const response = await saveUserData(currentUserData);
        triggerRefresh();
        if (response) {
            setCurrentUserData(response);
        }
    };

    return (
        <Box className={`user-personal-data ${className}`} width={'50%'} p={0} display={'flex'} flexDirection={'column'} gap={2} >
            <EditText object={currentUserData} objectField={'firstName'} setObjectField={setCurrentUserData} label={t('First name')} />
            <EditText object={currentUserData} objectField={'lastName'} setObjectField={setCurrentUserData} label={t('Last name')} />
            <EditText object={currentUserData} objectField={'phoneNumber'} setObjectField={setCurrentUserData} label={t('Phone number')} />
            <EditText object={currentUserData} objectField={'locale'} setObjectField={setCurrentUserData} label={t('Language')}
                options={[{ value: 'en', label: t('English') }, { value: 'es', label: t('Spanish') }, { value: 'ca', label: t('Catalan') }]} 
            />
            <CustomButton label={t('Save')} onClick={handleSave} disabled={isSaving} />
        </Box>
    );    
};

export default UserPersonalData;